import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/closeDia.svg'


const _withScopeId = n => (_pushScopeId("data-v-1462ec88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  class: "bottomBtn"
}
const _hoisted_6 = { class: "canceBtnText" }
const _hoisted_7 = { class: "saveBtnText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.lang == 'ar' ? 'reverse' : '')
  }, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      width: _ctx.width,
      "show-close": _ctx.showclose,
      "close-on-click-modal": false
    }, {
      header: _withCtx(() => [
        (_ctx.showTitle)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.title)), 1))
          : _createCommentVNode("", true),
        (_ctx.showclose)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
              class: "close"
            }, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.info) + " ", 1),
          _renderSlot(_ctx.$slots, "time", {}, undefined, true)
        ]),
        (_ctx.showBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                class: "cancelBtn diaBtn",
                onClick: _ctx.clickClose
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(_ctx.Cancel)), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                class: "saveBtn diaBtn",
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(_ctx.Okay)), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["modelValue", "width", "show-close"])
  ], 2))
}